import { api } from 'app/config/apiConfig';

import { ActivateBoxParams, Box } from '../model/types';

export const activateBoxApi = api.injectEndpoints({
  endpoints: (builder) => ({
    activateBox: builder.mutation<Box, ActivateBoxParams>({
      query: ({ boxId, shouldCreateWaitListNote }) => ({
        url: `/boxes/${boxId}/activate`,
        method: 'PUT',
        body: { shouldCreateWaitListNote },
      }),
      invalidatesTags: ['Boxes', 'Available boxes', 'Warehouses for booking'],
    }),
  }),
});

export const { useActivateBoxMutation } = activateBoxApi;
